import React, { FC } from 'react'
import {
  HasSidebarLayout,
  ListHeader,
  SensorBatteryStatsList,
} from 'src/components'

const SensorBatteryStatsListPage: FC = () => {
  document.title = 'CLīMIT Admin Panel - CLIMIT sensors battery analysis (BETA)'
  return (
    <HasSidebarLayout>
      <ListHeader title="CLIMIT sensors battery analysis (BETA)" />
      <SensorBatteryStatsList />
    </HasSidebarLayout>
  )
}

export default SensorBatteryStatsListPage
